import { AdminUser } from '../types';
import { appBackendApiClient } from './apiClient';

const mapUsers = (payload: any): AdminUser[] => {
  const users = Array.isArray(payload?.items) ? payload.items : [];

  return users.map((user: any) => ({
    id: String(user?.id || ''),
    name: String(user?.name || user?.email || 'Unknown user'),
    email: String(user?.email || ''),
    roleLabel: String(user?.roleLabel || 'User'),
    roles: Array.isArray(user?.roles)
      ? user.roles.filter(
          (role: unknown): role is string => typeof role === 'string'
        )
      : [],
    status:
      user?.status === 'active' ||
      user?.status === 'inactive' ||
      user?.status === 'suspended'
        ? user.status
        : 'inactive',
    joinedAt: String(user?.joinedAt || new Date(0).toISOString()),
    lastActiveAt: String(
      user?.lastActiveAt || user?.joinedAt || new Date(0).toISOString()
    ),
    pointsBalance: Number(user?.pointsBalance ?? 0),
    notes: String(user?.notes || ''),
  }));
};

export const AdminUserService = {
  async getUsers(): Promise<AdminUser[]> {
    const response = await appBackendApiClient.get('/auth/admin/users');
    return mapUsers(response.data);
  },

  async getUserById(id: string): Promise<AdminUser | null> {
    const users = await this.getUsers();
    return users.find((user) => user.id === id) || null;
  },
};
